/**
 * Development Logger Utility
 * Console logging that only runs in development mode
 */
const isDevelopment = process.env.NODE_ENV === "development";
/**
 * Development logger - only logs in development mode
 */
export const devLogger = {
    /**
     * Log information messages (only in development)
     */
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },
    /**
     * Log warning messages (only in development)
     */
    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },
    /**
     * Log error messages (only in development)
     */
    error: (...args) => {
        if (isDevelopment) {
            console.error(...args);
        }
    },
    /**
     * Log info messages (only in development)
     */
    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },
    /**
     * Log debug messages (only in development)
     */
    debug: (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    },
};
